import { render, staticRenderFns } from "./InHouse.vue?vue&type=template&id=2f9700cc&"
import script from "./InHouse.vue?vue&type=script&lang=js&"
export * from "./InHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports